export default {
  'base.notFound.title': 'Sorry, page not found',
  'base.notFound.desc': 'The page you visited does not exist or has been removed',
  'base.notFound.home': 'Back to home',
}
